<template>
  <div>
    <p class="cm-mg-p-wzd text-left text-muted">
      1.1 {{ $t('common_words.absence_enter_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-5 col-lg-5 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code')"
          :placeholder="`${$t('common_words.code_enter')}...`"
          @click="handleClickOnCode()"
        >
        </fg-input>
      </div>
      <div class="col-md-5 col-lg-5 col-xl-3">
        <fg-input
          :label="`${$t('common_words.name')}: *`"
          type="text"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.name_enter')}...`"
        ></fg-input>
      </div>
      <div class="col-md-5 col-lg-12 col-xl-2">
        <div class="form-group has-label">
          <label for="">{{ $t('common_words.status') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary mb-3 shadow-sm required-state"
            v-model="model.state"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in absenceState"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-5">
        <select-businesses-component
          class="required-business"
          ref="selectBusiness"
          :showLoading="false"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
    <div class="row"></div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import Businesses from 'src/components/Selects/Businesses.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';

export default {
  components: {
    [Businesses.name]: Businesses,
  },
  data() {
    return {
      model: {
        name: null,
        code: null,
        state: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
      },
    };
  },
  computed: {
    absenceState() {
      return [
        { id: 'activo', value: i18n.t('labor.active') },
        { id: 'inactivo', value: i18n.t('labor.inactive') },
        { id: 'en espera', value: i18n.t('on_hold') },
      ];
    },
  },
  mixins: [MixinPermissions, mixinMasters, MixinForm],
  methods: {
    handleClickOnCode() {
      const tableCodes = Object(
        JSON.parse(sessionStorage.getItem('tableCode'))
      );

      if (!isset(this.model.code)) {
        this.codeGenerator(i18n.t('types_of_absence'), tableCodes, 'code');
      }
    },

    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },

    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', { ...this.model });

          return res;
        })
        .then((resp) => {
          if (!resp) return resp;
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else if (!isset(this.model.state)) {
            return this.validationInputsRequired('state');
          } else {
            return true;
          }
        });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      let editForm = {};
      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        editForm = JSON.parse(sessionStorage.getItem('editForm'));
        this.model = { ...editForm };
        this.model.businesses_id = editForm.businesses.map(
          (business) => business.id
        );
      }
      setTimeout(() => {
        this.showHideLoading();
      }, 1000);
    } else this.showHideLoading();
  },
};
</script>
<style></style>
